export default "__VITE_ASSET__DpXgQoSh__"